// Angular
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedService } from '../../../../shared/sharedServices/shared.service';
import { RegisterService } from './services/register.service';
import { CommonHelper } from '../../../../core/_config/common.helper';
import { HecResponse } from '../../../../shared/shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { SearchCountryField, TooltipLabel, CountryISO } from 'ngx-intl-tel-input';
import { GoogleAnalyticsService } from '../../../../shared/sharedServices/google-analytics.service';
// import { stepper } from '../../../../route-animations';

@Component({
	selector: 'kt-register',
	templateUrl: './register.component.html',
	// animations: [ // <-- add your animations here
	// fader,
	// slider,
	// transformer,
	// stepper
	//   ],
	encapsulation: ViewEncapsulation.None
})
export class RegisterComponent implements OnInit, OnDestroy {
	public registerForm: FormGroup;
	public separateDialCode = true;
	public SearchCountryField = SearchCountryField;
	public TooltipLabel = TooltipLabel;
	public CountryISO = CountryISO;
	public verificationForm: FormGroup;
	public loading = false;
	public errors: any = [];
	public countriesDialingCodes: Array<any>;
	public countriesList: any;
	public checkDuplicateCnic: boolean = true;
	public nationalityId: number;
	public countryCode: any;
	public cellPhoneLayload: any;
	public cnicType: number;
	public phide: boolean = true
	public cphide: boolean = true
	public login: any;
	public userCellNumber: string = '';
	public dialingCode: any;
	public isAlertVisible: boolean = false;
	public alertClass: string;
	public alertIcon: string;
	public alertMsgValue: string;
	public registerSuccess: boolean = false;
	public loader: boolean = false;
	public resendSMSCodeSeconds: boolean = false;
	public resendEmailCodeSeconds: boolean = false;
	public verificationPayload: any;
	public resendCodeTimer;
	public cellPhone;
	public emailVerified: boolean = false;
	public phoneVerified: boolean = false;
	public changeEmail: boolean = false;
	public changeMobile: boolean = false;
	public alertType: string;
	public showMinutes: boolean = false
	public showSMSMinutes: boolean = false
	@ViewChild('smsseconds', { static: false }) selementView: ElementRef;
	@ViewChild('emailseconds', { static: false }) eelementView: ElementRef;
	@ViewChild('cnic', { static: false }) cnic: ElementRef;
	@ViewChild('poc', { static: false }) poc: ElementRef;
	@ViewChild('minutes', { static: false }) minutesElementView: ElementRef;
	public filledCaptcha: ElementRef;
	constructor(
		private router: Router,
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef,
		private sharedServices: SharedService,
		private registerService: RegisterService,
		private gaService: GoogleAnalyticsService,
	) {
	}

	ngOnInit() {
		this.gaService.setPage('/register', 'Register');
		this.initRegisterForm();
		this.getCountriesList();
		this.getCountriesDialingCodes();
	}

	ngAfterViewInit() {
		setTimeout(() => {
			if (document.getElementById('km-forgotpassword')) document.getElementById('km-forgotpassword').classList.add('active');
		}, 100);
	}

	ngOnDestroy(): void {
		this.loading = false;
	}

	public initRegisterForm() {
		this.registerForm = this.fb.group({
			firstName: ['', Validators.compose([
				Validators.required,
				Validators.maxLength(50)
			])
			],
			lastName: ['', Validators.compose([
				Validators.required,
				Validators.maxLength(100)
			])
			],
			nationality: [
				'', Validators.compose([
					Validators.required
				])
			],
			cnic: [
				'', Validators.compose([
					Validators.minLength(13),
					Validators.maxLength(13),
					Validators.pattern('^[0-9]*$')
				])
			],
			userName: [
				null, [
					Validators.pattern('^[A-Z0-9]+$')
				]
			],
			email: ['', Validators.compose([
				Validators.required,
				Validators.email,
				Validators.maxLength(50)
			]),
			],
			password: ['', Validators.compose([
				Validators.required,
				Validators.minLength(8),
				Validators.maxLength(20)
			])
			],
			confirmPassword: ['', Validators.compose([
				Validators.required,
				Validators.minLength(8),
				Validators.maxLength(20)
			])
			],
			contactCountry: ['', Validators.compose([
				Validators.required
			])],
			nicType: ['', Validators.compose([
				Validators.required
			])],
		}, {
			// validator: ConfirmPasswordValidator.MatchPassword
		});
	}

	public async sendVerificationCodes(): Promise<void> {
		this.isAlertVisible = false;
		await this.getSelectedCountry();
		this.markFormsTouched(this.registerForm)
		if (this.validate(this.registerForm) && this.checkDuplicateCnic) {
			let payload = {
				data: {
					// contactNumber: this.userCellNumber,
					// contactCountry: this.countryCode,
					email: this.registerForm.value.email
				}
			}
			if (this.registerForm.value.nationality == 1) {
				payload.data['userNameType'] = 1
				payload.data['cnic'] = this.registerForm.value.cnic
				delete payload.data['userName'];
			} else {
				payload.data['userNameType'] = 3
				delete payload.data['cnic']
				payload.data['userName'] = this.registerForm.value.userName
			}

			this.registerService.verifyContactAndSendCode(payload).subscribe(
				(res: HecResponse) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						if (!res.data.isEmailExists && !res.data.isNumberExists) {
							this.loader = false;
							this.isAlertVisible = true;
							this.alertType = HEC_CONSTANTS.ERROR_TYPES.success;
							this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.OPT_SUCCESS_CODE;
							this.registerSuccess = true;
							this.resendSMSCodeSeconds = false;
							this.resendEmailCodeSeconds = false;
							this.showMinutes = true
							this.showSMSMinutes = true
							this.getverificationForm();
							this.cdr.detectChanges();
							this.cdr.markForCheck();
							if (this.showCellPhoneVerificationField()) this.getCellPhoneTimer();
							this.getEmailTimer();
						} else if (res.data.isEmailExists && !res.data.isNumberExists) {
							this.loader = false;
							this.isAlertVisible = true;
							this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
							this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.EMAIL_CELL_ALREADY_REGISTERED;
							this.cdr.detectChanges();
						}
						else if (!res.data.isEmailExists && res.data.isNumberExists) {
							this.loader = false;
							this.isAlertVisible = true;
							this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
							this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.CELL_ALREADY_REGISTERED;
							this.cdr.detectChanges();
						} else {
							this.loader = false;
							this.isAlertVisible = true;
							this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
							this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.EMAIL_ALREADY_REGISTERED;
							this.cdr.detectChanges();
						}
					} else {
						this.loader = false;
						this.isAlertVisible = true;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.SOMETHING_ERROR;
						this.cdr.detectChanges();
					}
				},
				(err) => {
					this.loader = false;
					this.isAlertVisible = true;
					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
					this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.SOMETHING_ERROR;
					this.cdr.detectChanges();
				}
			)
		}
	}

	public resendCellCodeVerificationCode(): void {
		this.isAlertVisible = false;
		let payload = {
			data: {
				contactValue: this.userCellNumber,
				verificationTypeId: 703105,
				countryId: this.countryCode,
				checkEmail: false,
				isRegister: true
			}
		}

		this.sharedServices.postSendMobileVerificationCode(payload).subscribe(
			(res) => {
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					this.isAlertVisible = true;
					this.alertType = HEC_CONSTANTS.ERROR_TYPES.success;
					this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.CELL_PHONE_CODE_RESEND;
					this.resendSMSCodeSeconds = false
					this.showSMSMinutes = true
					this.cdr.detectChanges();
					this.InitSMSTimer();
					this.getCellPhoneTimer();
				}
			})
	}

	public resendEmailVerificationCode(): void {
		this.isAlertVisible = false;
		let payload = {
			data: {
				contactValue: this.registerForm.value.email,
				verificationTypeId: 703103,
				checkEmail: true,
				isRegister: true
			}
		}
		this.sharedServices.postSendEmailVerificationCode(payload).subscribe(
			(res) => {
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					this.isAlertVisible = true;
					this.alertType = HEC_CONSTANTS.ERROR_TYPES.success;
					this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.EMAIL_CODE_RESEND;
					this.resendEmailCodeSeconds = false
					this.showMinutes = true
					this.cdr.detectChanges();
					this.InitEmailTimer();
					this.getEmailTimer();
				}
			})
	}

	public submitVerificationCode(): void {
		this.isAlertVisible = false;
		this.markFormsTouched(this.verificationForm)
		if (this.validate(this.verificationForm)) {
			this.loader = true;
			let emailCodePayload = {
				data: {
					contactValue: this.registerForm.value.email,
					code: this.verificationForm.value.emailCode,
					verificationTypeId: "703103",
					countryId: '',
					userPrincipalName: this.registerForm.value.nationality == 1 ? this.registerForm.value.cnic : this.registerForm.value.userName

				}
			}

			// phoneCodePayload wont be used as we are not taking phoneCode OTP now
			let phoneCodePayload = {
				data: {
					contactValue: this.userCellNumber,
					// code: this.verificationForm.value.cellPhoneCode,
					verificationTypeId: "703105",
					countryId: this.countryCode,
					userPrincipalName: this.registerForm.value.nationality == 1 ? this.registerForm.value.cnic : this.registerForm.value.userName

				}
			}
			this.sharedServices.postVerificationCode(emailCodePayload).subscribe(
				(res: HecResponse) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						this.submitRegister();

						// if (this.showCellPhoneVerificationField() && phoneCodePayload.data.code) {
						// 	this.sharedServices.postVerificationCode(phoneCodePayload).subscribe(
						// 		(res: HecResponse) => {
						// 			if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						// 				this.submitRegister();
						// 			} else {
						// 				this.isAlertVisible = true;
						// 				this.loader = false;
						// 				this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						// 				this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.PHONE_NUMBER_CODE_INVALID;
						// 				this.cdr.detectChanges();

						// 			}
						// 		},
						// 		(err) => {
						// 			this.isAlertVisible = true;
						// 			this.loader = false;
						// 			this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						// 			this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.SOMETHING_ERROR;
						// 			this.cdr.detectChanges();
						// 		}
						// 	)
						// }
						// else {
						// 	this.submitRegister();
						// }
					} else {
						this.isAlertVisible = true;
						this.loader = false;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.EMAIL_CODE_INVALID;
						this.cdr.detectChanges();
					}
				},
				(err) => {
					this.isAlertVisible = true;
					this.loader = false;
					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
					this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.SOMETHING_ERROR;
					this.cdr.detectChanges();
				}
			)
		} else {
			return;
		}
	}

	public editRegister() {
		this.registerSuccess = false;
		this.isAlertVisible = false;
		this.resendCodeTimer = new Date();
		if (this.selementView != undefined) {
			this.selementView.nativeElement.innerText = 0;
			this.resendSMSCodeSeconds = true;
			this.cdr.detectChanges();

		}
		if (this.eelementView != undefined) {
			this.eelementView.nativeElement.innerText = 0;
			this.resendEmailCodeSeconds = true;
			this.cdr.detectChanges();
		}
		this.resendEmailCodeSeconds = true;
		this.resendSMSCodeSeconds = true;
		this.cdr.detectChanges();
	}

	public getverificationForm(): void {
		this.verificationForm = this.fb.group({
			emailCode: ['', Validators.required],
			// cellPhoneCode: [''],
			// captchaControl: ['', Validators.required]
		})
	}

	public async submitRegister(): Promise<void> {
		if (this.registerForm.value.nationality == 1) {
			this.registerForm.value.passportNumber = undefined;
			this.registerForm.value.nicType = this.cnicType;
			this.registerForm.value.userNameType = 1;
			this.registerForm.value.provinceId = 2;
			delete this.registerForm.value.passportNumber;
		} else {
			this.registerForm.value.nicType = undefined;
			this.registerForm.value.userNameType = 3;
			this.registerForm.value.passportNumber = this.registerForm.value.userName
			delete this.registerForm.value.cnic;
			delete this.registerForm.value.provinceId;
		}
		this.registerForm.value.contactCountry = this.countryCode;
		this.registerForm.value.contactNumber = this.userCellNumber;
		delete this.registerForm.value.confirmPassword;
		this.markFormsTouched(this.registerForm)
		if (this.validate(this.registerForm) && this.checkDuplicateCnic) {
			this.loading = true;
			let formpaylaod = {
				data: this.registerForm.value
			}
			formpaylaod.data.cv = this.filledCaptcha;

			this.registerService.registerUser(formpaylaod).subscribe(
				(res: HecResponse) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						this.isAlertVisible = true;
						this.loader = false;
						this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.ACCOUNT_CREATED;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.success;
						this.cdr.detectChanges();

						setTimeout(() => {
							this.router.navigate(['/auth/login'])
						}, 2000)
					}
					else if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.BUSINESS_ERROR) {
						this.loader = false;
						this.loading = false;
						this.isAlertVisible = true;
						this.alertMsgValue = res.statusDescription;
						this.cdr.detectChanges();
					}
					else {
						this.loader = false;
						this.loading = false;
						this.cdr.detectChanges();
						this.isAlertVisible = true;
						this.alertMsgValue = 'Something went wrong. Please try again.'//res.statusDescription;
						this.cdr.detectChanges();
					}
				},
			)
		}
	}

	public isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.registerForm.controls[controlName];
		if (!control) {
			return false;
		}

		const result = control.hasError(validationType) && (control.dirty || control.touched);
		return result;
	}

	public getSelectedCountry() {
		this.loader = true;
		return new Promise((resolve, reject) => {
			if (this.registerForm.controls.contactCountry.status == 'VALID') {
				this.dialingCode = this.registerForm.controls.contactCountry.value.dialCode;
				let countryCode = this.registerForm.controls.contactCountry.value.countryCode;
				this.userCellNumber = this.registerForm.controls.contactCountry.value.number.replace(/[^A-Z0-9]/ig, "");
				this.sharedServices.getCountryByDialingCode(this.dialingCode, countryCode).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK && res.data != undefined) {
							this.countryCode = res.data.value;
							resolve(this.countryCode)
							this.cdr.detectChanges();

						}
					}
				)
			}
		});
	}

	public getCountriesList(): any {
		return new Promise((resolve, reject) => {
			this.sharedServices.getCountryList().subscribe(
				(res) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						this.countriesList = res.data.filter(country => country.value !== 29);
						this.registerForm.controls.nationality.patchValue(1);
						this.getSelectedNationalityCountry(1);
						this.registerForm.controls.nicType.patchValue("1");
						this.selectedcnicType(1)
						resolve(this.countriesList);
						this.cdr.detectChanges();
					}
				})
		})
			.catch(function (error) {
			})
	}

	public getCountriesDialingCodes(): any {
		return new Promise((resolve, reject) => {
			this.sharedServices.getCountriesDialingCode().subscribe(
				(res) => {
					this.countriesDialingCodes = res.data;
					resolve(this.countriesDialingCodes);
				}
			)
		})
			.catch(function (error) {
			})
	}

	public checkDuplicateCnicOrUsername(userName): void {
		let payload = {
			data: userName
		}
		this.registerService.getDuplicationUsernameCnicCheck(payload).subscribe(
			(res) => {
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					this.checkDuplicateCnic = res.data;
					this.isAlertVisible = false;

					this.cdr.detectChanges();
				}
				else if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.BUSINESS_ERROR) {
					if (this.cnicType == 1 && this.nationalityId == 1) {
						this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.CNIC_ALREADY_REGISTER;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.warning
					} else if (this.cnicType == 2 && this.nationalityId == 1) {
						this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.POC_ALREADY_REGISTER;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.warning
					} else {
						this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.PASSPORT_ALREADY_REGISTER;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.warning
					}
					this.checkDuplicateCnic = false;
					this.isAlertVisible = true;
					this.cdr.detectChanges();
				}
			},
			(err) => {
				this.checkDuplicateCnic = false;
				this.cdr.detectChanges();
			}
		)
	}
	public getSelectedNationalityCountry(countryId): void {
		this.nationalityId = countryId;
		if (countryId != 1) {
			this.checkDuplicateCnic = true;
			this.registerForm.controls.userName.reset();
			this.isAlertVisible = true;
			this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.OVERSEAS_PAKISTANI_WARNING
			this.alertType = HEC_CONSTANTS.ERROR_TYPES.warning
		} else {
			this.registerForm.controls.nicType.reset();
			this.registerForm.controls.userName.reset();
			this.registerForm.controls.cnic.reset();
			this.registerForm.controls.nicType.patchValue("1");
			this.checkDuplicateCnic = true;
			this.isAlertVisible = false;
		}
		this.cdr.detectChanges();
		if (countryId == 1) {
			this.registerForm.get('userName').setValidators(null);
			this.registerForm.get('userName').updateValueAndValidity()
			this.registerForm.get('cnic').setValidators([Validators.required]);
			this.registerForm.get('cnic').updateValueAndValidity()
			this.registerForm.get('nicType').setValidators([Validators.required]);
			this.registerForm.get('nicType').updateValueAndValidity()
		} else if (countryId == 193) {
			this.registerForm.get('userName').setValidators([
				Validators.required,
				Validators.pattern('^[A-Z0-9]+$')
			]);
			this.registerForm.get('userName').updateValueAndValidity()
			this.registerForm.get('cnic').setValidators(null);
			this.registerForm.get('cnic').updateValueAndValidity()
			this.registerForm.get('nicType').setValidators(null);
			this.registerForm.get('nicType').updateValueAndValidity()
		} else if (countryId == 18) {
			this.registerForm.get('userName').setValidators([
				Validators.required,
				Validators.pattern('^[A-Z0-9]+$')
			]);
			this.registerForm.get('userName').updateValueAndValidity()
			this.registerForm.get('cnic').setValidators(null);
			this.registerForm.get('cnic').updateValueAndValidity()
			this.registerForm.get('nicType').setValidators(null);
			this.registerForm.get('nicType').updateValueAndValidity()
		}
		else {
			this.registerForm.get('userName').setValidators([
				Validators.required,
				Validators.pattern('^[A-Z0-9]+$')
			]);
			this.registerForm.get('userName').updateValueAndValidity()
			this.registerForm.get('cnic').setValidators(null);
			this.registerForm.get('cnic').updateValueAndValidity()
			this.registerForm.get('nicType').setValidators(null);
			this.registerForm.get('nicType').updateValueAndValidity()
		}
	}

	public markFormsTouched(form): void {
		CommonHelper.markFormGroupTouched(form);
	}

	public validate(registerForm): boolean {
		if (registerForm.status === 'VALID') {
			return true;
		}
	}

	public selectedcnicType(cnicType) {
		this.cnicType = cnicType
	}

	public getCellPhoneTimer(): void {
		if (this.resendSMSCodeSeconds == false) {
			setInterval(() => {
				if (this.resendSMSCodeSeconds == false) {
					if (Number(this.selementView.nativeElement.innerText) > 0) {

						if (this.minutesElementView && this.minutesElementView.nativeElement.innerText && Number(this.minutesElementView.nativeElement.innerText) == 0) {
							this.showSMSMinutes = false
							this.cdr.detectChanges();

						}

						if (Number(this.selementView.nativeElement.innerText) == 1 && (!this.minutesElementView || Number(this.minutesElementView.nativeElement.innerText == 0))) {

							this.resendSMSCodeSeconds = true;
							this.cdr.detectChanges();


						}
					}
				}
			}, 1000)
		}
		setTimeout(() => {
			this.InitSMSTimer();
		}, 500)
	}

	public getEmailTimer(): void {
		if (this.resendEmailCodeSeconds == false) {
			setInterval(() => {
				if (Number(this.eelementView.nativeElement.innerText) > 0) {

					if (this.minutesElementView && this.minutesElementView.nativeElement.innerText && Number(this.minutesElementView.nativeElement.innerText) == 0) {
						this.showMinutes = false
						this.cdr.detectChanges();

					}

					if (Number(this.eelementView.nativeElement.innerText) == 1 && (!this.minutesElementView || Number(this.minutesElementView.nativeElement.innerText == 0))) {

						this.resendEmailCodeSeconds = true;
						this.cdr.detectChanges();


					}
				}
			}, 1000)
		}
		setTimeout(() => {
			this.InitEmailTimer();
		}, 500)
	}

	public InitSMSTimer(): void {
		this.resendCodeTimer = new Date();
		this.resendCodeTimer.setMinutes(this.resendCodeTimer.getMinutes() + 1);
		function getTimeRemaining(endtime) {
			endtime = new Date(endtime);
			let t = 0;
			let seconds = 0;
			if (endtime > new Date()) {
				t = endtime.getTime() - new Date().getTime();
				seconds = Math.floor((t / 1000) % 60);
			}
			return {
				'total': t,
				'seconds': seconds,
			};
		}
		function initializeClock(id, endtime) {
			const clock = document.getElementById(id);
			const secondsSpan = clock.querySelector('.seconds');
			function updateClock() {
				const t = getTimeRemaining(endtime);
				secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
				if (t.total <= 0) {
					clearInterval(timeinterval);
				}
			}
			updateClock();
			const timeinterval = setInterval(updateClock, 1000);
		}

		initializeClock('clockdivSMS', this.resendCodeTimer);
	}

	public InitEmailTimer(): void {
		this.resendCodeTimer = new Date();
		this.resendCodeTimer.setMinutes(this.resendCodeTimer.getMinutes() + 1);
		function getTimeRemaining(endtime) {
			endtime = new Date(endtime);
			let t = 0;
			let seconds = 0;
			if (endtime > new Date()) {
				t = endtime.getTime() - new Date().getTime();
				seconds = Math.floor((t / 1000) % 60);
			}
			return {
				'total': t,
				'seconds': seconds,
			};
		}
		function initializeClock(id, endtime) {
			const clock = document.getElementById(id);
			const secondsSpan = clock.querySelector('.seconds');
			function updateClock() {
				const t = getTimeRemaining(endtime);
				secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
				if (t.total <= 0) {
					clearInterval(timeinterval);
				}
			}
			updateClock();
			const timeinterval = setInterval(updateClock, 1000);
		}
		initializeClock('clockdivEmail', this.resendCodeTimer);
	}

	showCellPhoneVerificationField = () => true;

	public resolved(value): void {
		this.filledCaptcha = value;
	}
}
